<template>
  <button
    type="button"
    class="dropdown-item"
    v-bind="passthroughAttrs"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdDropdownItemButton',

  inheritAttrs: false,

  emits: ['click'],

  computed: {
    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
